import baustein from "baustein";
import analytics from "web/script/analytics/analytics";

export default baustein.register("ga-client-id-input", {
    defaultOptions: {
        name: "clientId",
    },

    init: function () {
        analytics.getGAClientID().then(
            function (clientId) {
                this.el.value = clientId;
            }.bind(this)
        );
    },

    createRootElement: function () {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = this.options.name;
        return input;
    },
});
